import { useMemo } from 'react';
import { useTransactionsQuery } from '../api/useTransactionsQuery';
import { useRouteParams } from './useRouteParams';
import { useTransactionFilters } from './useTransactionFilters';

export const useTransactions = () => {
  const transactionFilters = useTransactionFilters();

  const { accountId, clientId, groupId } = useRouteParams();

  const queryInfo = useTransactionsQuery({
    clientId,
    accountId,
    groupId,
    ...transactionFilters,
    period: transactionFilters.period.value,
    startDate: transactionFilters.period.dates[0],
    endDate: transactionFilters.period.dates[1],
  });

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    return {
      data: queryInfo.data.pages,
    };
  }, [queryInfo]);

  return { ...queryInfo, data: { ...data, transactionFilters } };
};
